import { render } from "./JjlbSetDialog.vue?vue&type=template&id=19476024&scoped=true"
import script from "./JjlbSetDialog.vue?vue&type=script&lang=js"
export * from "./JjlbSetDialog.vue?vue&type=script&lang=js"

import "./JjlbSetDialog.vue?vue&type=style&index=0&id=19476024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19476024"]])

export default __exports__